import { withInstall } from '../../../utils/with-install'
import Text from './Text.vue'

export const ElAmapText = withInstall(Text)
export default ElAmapText
